import "../assets/index-fc61f2d8.css";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const r = {
  name: "NcAppNavigationIconBullet",
  props: {
    color: {
      type: String,
      required: !0,
      validator(t) {
        return /^#?([0-9A-F]{3}){1,2}$/i.test(t);
      }
    }
  },
  emits: ["click"],
  computed: {
    formattedColor() {
      return this.color.startsWith("#") ? this.color : "#" + this.color;
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  }
};
var i = function() {
  var o = this, e = o._self._c;
  return e("div", { staticClass: "app-navigation-entry__icon-bullet", on: { click: o.onClick } }, [e("div", { style: { backgroundColor: o.formattedColor } })]);
}, l = [], c = /* @__PURE__ */ n(
  r,
  i,
  l,
  !1,
  null,
  "91580127",
  null,
  null
);
const _ = c.exports;
export {
  _ as default
};
